import "../styles/index.css";

import {initGlider} from "./gliderInit";
// import {initSlick} from "./slickInit";

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

function throttle(fn, wait) {
    var time = Date.now();
    return function () {
        if ((time + wait - Date.now()) < 0) {
            fn();
            time = Date.now();
        }
    }
}




function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}



function changeView(v) {
    setCookie('view', v, 1)
    var eventsContainer=document.querySelector('.Events__days-container');
    console.log('change to ',v)
    if(!eventsContainer){
        return
    }
    if(v==='grid'){
        eventsContainer.classList.remove('Events__days-container--list')
    }else{
        eventsContainer.classList.add('Events__days-container--list')
    }
}


function isScrolledIntoView(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;

    // Only completely visible elements return true:
    // var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // Partially visible elements return true:
    var isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
}




jQuery(document).ready(function () {
    console.log('$')
    $('body').addClass('initialized');


    
    $(document).on('click', '.Categories-filter .Tag', function (e) {
        // console.log(e.target.dataset.tags, $(e.target))

        const clickedElementTagsArray=e.target.dataset.tags.split(',').filter(v=>!!v);

        $('.List-of-items .List-item').removeClass('hidden')

        if($(e.target).hasClass('active')){
            $(e.target).removeClass('active');
            $('.Categories-filter .Tag.Tag-all').addClass('active');

            
        }else{
            $('.Categories-filter .Tag').removeClass('active');
            $(e.target).addClass('active');

            if($(e.target).hasClass('Tag-all')){
                return;
            }
            

            $('.List-of-items .List-item').each(function(i, obj) {

                const objTags=$(obj).attr('data-tags');
                if(objTags){
                    const tagsArray = objTags.split(',').filter(v=>!!v);
                    console.log(tagsArray)

                    const objectHasIntersection =tagsArray.some(v=>clickedElementTagsArray.includes(v))
                    if(!objectHasIntersection){
                        $(obj).addClass('hidden')
                    }
                }
                
           
            })
        }

    })







    initGlider();

    $(document).on('click', '.change-view', function (e) {
        console.log(e.target.dataset.view)
        changeView(e.target.dataset.view)
    })


    $(document).on('click', '.Faq', function (e) {
        var addClass=false;
        if(!$(this).hasClass('Faq--active')){
            addClass=true;

        }

        $('.Faq--active').find('.Faq__answer').hide('slow')

        $('.Faq').removeClass('Faq--active');
        if(addClass) {
            $(this).addClass('Faq--active');
            $(this).find('.Faq__answer').show('slow')
        }
    });


    $(document).on('click', '.ScrollTrigger', function (e) {
        e.preventDefault();
        var elementToScrollTo = $(this).data('scroll');


        var new_position = $(elementToScrollTo).offset();
        $('html, body').stop().animate({scrollTop: new_position.top}, 500);


        // document.querySelector(elementToScrollTo).scrollIntoView({ behavior: 'smooth' })
        console.log('clicked scroll', elementToScrollTo)
    });




    var youtubeAutoplayContainer = document.querySelector('.youtube-autoplay-on-scroll');


    var myEfficientFn = debounce(function () {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;

        // console.log('throttled scroll '+scrollY);


        if (scrollY < window.innerHeight/2) {
            $('body').removeClass('scrolled-under-header')
        } else {
            $('body').addClass('scrolled-under-header')
        }

        if (scrollY < 50) {
            $('body').removeClass('scrolled-down')
        } else {
            $('body').addClass('scrolled-down')
        }


        if(youtubeAutoplayContainer) {
            if(isScrolledIntoView(youtubeAutoplayContainer)){
            // console.log('in view');
            var videoUrl = $('.youtube-autoplay-on-scroll iframe').attr('src');
            var pattern = /autoplay/;
            var apexists = pattern.test(videoUrl);
            if (!apexists) {
                // console.log('adding autoplay');
                $('.youtube-autoplay-on-scroll iframe').attr('src', videoUrl + "&autoplay=1");
            }
        }
        }


    }, 20, false);

    window.addEventListener("scroll", myEfficientFn);

    window.scroll()


    // Find all YouTube videos
    // Expand that selector for Vimeo and whatever else
    var $allVideos = $("iframe[src*='youtube.com']"),
    // var $allVideos = $(".Video__embed-container iframe"),
        // var $allVideos = $("iframe[src^='//www.youtube.com']"),
        // The element that is fluid width
        // $fluidEl = $("body");
        $fluidEl = $(".Section .MainText, .video-wrapper");
        // $fluidEl = $(".Video__embed-container");

    // var $video=$(".Video__embed-container");

    // console.log('v',$video)
    // console.log('all videos',$allVideos)
    // Figure out and save aspect ratio for each video
    $allVideos.each(function () {
        console.log('v each')

        $(this)
            .data('aspectRatio', this.height / this.width)

            // and remove the hard coded width/height
            .removeAttr('height')
            .removeAttr('width');

    });

    // When the window is resized
    $(window).resize(function () {

        // --md-viewport-down (max-width: 1023px);

        var newWidth = $fluidEl.width();

        // Resize all videos according to their own aspect ratio
        $allVideos.each(function () {

            var $el = $(this);
            $el
                .width(newWidth)
                .height(newWidth * $el.data('aspectRatio'));

        });

        var bodyFullGradient = document.querySelector('.has-full-gradient');
        if (bodyFullGradient) {
            bodyFullGradient.style.backgroundSize = "100% " + document.documentElement.scrollHeight + 'px';
        }


        var lines = document.getElementById('Lines');
        if (lines) {

            lines.setAttribute("viewBox", "0 0 " + window.innerWidth + ' ' + window.innerHeight);
            lines.setAttribute("width", window.innerWidth);
            lines.setAttribute("height", window.innerHeight);
            initLines(window.innerWidth, window.innerHeight);


            // lines.setAttribute("viewBox", "0 0 "+window.innerWidth+' '+window.innerHeight);
            // lines.setAttribute("width", window.innerWidth);
            // lines.setAttribute("height", window.innerHeight);

            // if(window.innerHeight>=window.innerWidth){
            //     window.innerHeight
            //     lines.setAttribute("width", 'auto');
            //     lines.setAttribute("height", '100%');
            // }else{
            //     lines.setAttribute("width", '100%');
            //     lines.setAttribute("height", 'auto');
            // }


            // lines.setAttribute("width", window.innerWidth);
            // lines.setAttribute("height", window.innerHeight);
        }


// Kick off one resize to fix all videos on page load
    }).resize();


});